import React from 'react';

import { UserProvider, useUser } from '../../context/UserContext'

import ProfileNav from './profile-nav';
import ProfileContent from './profile-content';


export default function Home() {
  return (
    <div className="layout profile">
      <ProfileNav />
      <ProfileContent />
    </div>
  )
}